/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Users_CreatedInputs */

const en_users_created = /** @type {(inputs: Users_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`User created (${i?.displayName}). Cognito sends the user an invitation email with a temporary password.`)
};

const pt_br2_users_created = /** @type {(inputs: Users_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usuário criado (${i?.displayName}). O Cognito envia um e-mail de convite com senha temporária.`)
};

/**
* | output |
* | --- |
* | "User created ({displayName}). Cognito sends the user an invitation email with a temporary password." |
*
* @param {Users_CreatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_created = /** @type {((inputs: Users_CreatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_CreatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_created(inputs)
	return pt_br2_users_created(inputs)
});